/** Stored API / DB values for incident objective classification */
export const OBJECTIVE_TYPE_OPERATIONAL = 'Operational';
export const OBJECTIVE_TYPE_MANAGEMENT = 'Management';
export const OBJECTIVE_TYPE_OPERATIONAL_AND_MANAGERIAL =
  'OperationalAndManagerial';

export const incidentObjectiveTypeSegments = [
  {
    value: OBJECTIVE_TYPE_OPERATIONAL,
    abbrev: 'O',
    tooltip: 'Operational',
  },
  {
    value: OBJECTIVE_TYPE_MANAGEMENT,
    abbrev: 'M',
    tooltip: 'Managerial',
  },
  {
    value: OBJECTIVE_TYPE_OPERATIONAL_AND_MANAGERIAL,
    abbrev: 'O&M',
    tooltip: 'Operational & Managerial',
  },
] as const;

export function normalizeIncidentObjectiveType(
  type: string | undefined | null
): string {
  if (type === OBJECTIVE_TYPE_MANAGEMENT) return OBJECTIVE_TYPE_MANAGEMENT;
  if (type === OBJECTIVE_TYPE_OPERATIONAL_AND_MANAGERIAL) {
    return OBJECTIVE_TYPE_OPERATIONAL_AND_MANAGERIAL;
  }
  return OBJECTIVE_TYPE_OPERATIONAL;
}
